"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseObject = void 0;
var BaseObject = /** @class */ (function () {
    function BaseObject() {
        var _this = this;
        this.id = undefined;
        this.init = function (obj) {
            if (!(obj == undefined)) {
                Object.assign(_this, obj);
                _this.applyTypes();
            }
            return _this;
        };
        this.javaType = function () { return undefined; };
        this.BaseObject_applyTypes = function () {
            _this.id = _this.typeNumber(_this.id);
        };
        this.typeEnumArray = function (enumType, arr) {
            var me = _this;
            var conv = function (value) {
                return me.typeEnum(enumType, value);
            };
            var output = _this.typeArray(conv, arr);
            return output;
        };
        this.typeEnum = function (enumType, value) {
            try {
                if (!(value == undefined)) {
                    return enumType[String(value)];
                }
            }
            catch (ex) {
            }
            return undefined;
        };
        this.typeBooleanArray = function (arr) {
            return _this.typeArray(_this.typeBoolean, arr);
        };
        this.typeBoolean = function (value) {
            try {
                if (!(value == undefined)) {
                    return Boolean(value);
                }
            }
            catch (ex) {
            }
            return undefined;
        };
        this.typeStringArray = function (arr) {
            return _this.typeArray(_this.typeString, arr);
        };
        this.typeString = function (value) {
            try {
                if (!(value == undefined)) {
                    return String(value);
                }
            }
            catch (ex) {
            }
            return undefined;
        };
        this.typeDateArray = function (arr) {
            return _this.typeArray(_this.typeDate, arr);
        };
        this.typeDate = function (value) {
            try {
                if (!(value == undefined)) {
                    return new Date(value);
                }
            }
            catch (ex) {
            }
            return undefined;
        };
        this.typeNumberArray = function (arr) {
            return _this.typeArray(_this.typeNumber, arr);
        };
        this.typeNumber = function (value) {
            try {
                if (!(value == undefined)) {
                    return Number(value);
                }
            }
            catch (ex) {
            }
            return undefined;
        };
        this.typeObjectArray = function (creator, arr) {
            var output = new Array();
            if (!(arr == undefined)) {
                for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
                    var element = arr_1[_i];
                    if (element != undefined) {
                        var typedElement = _this.typeObject(creator, element);
                        if (typedElement != undefined) {
                            output.push(typedElement);
                        }
                    }
                }
            }
            return output;
        };
        this.typeObject = function (creator, obj) {
            if (!(obj == undefined)) {
                var typedObj = creator();
                Object.assign(typedObj, obj);
                typedObj.applyTypes();
                return typedObj;
            }
            return undefined;
        };
        this.typeArray = function (convert, arr) {
            var output = new Array();
            if (!(arr == undefined)) {
                for (var _i = 0, arr_2 = arr; _i < arr_2.length; _i++) {
                    var element = arr_2[_i];
                    if (element != undefined) {
                        var typedElement = convert(element);
                        if (typedElement != undefined) {
                            output.push(typedElement);
                        }
                    }
                }
            }
            return output;
        };
    }
    BaseObject.prototype.applyTypes = function () {
        this.BaseObject_applyTypes();
    };
    return BaseObject;
}());
exports.BaseObject = BaseObject;
